import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';

const defaultState = {
  isLoadingBenchmarkAttributes: false,
  isLoadingAttributeAssociations: false,
  isLoadingEmployeeAttributes: false,
  isLoadingUnmappedValues: false,
  isLoadingBenchmarkQuestions: false,
  isLoadingUntaggedQuestions: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const benchmarkUI = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(benchmarkActions.fetchAllBenchmarkAttributes.pending, merge({ isLoadingBenchmarkAttributes: true }))
    .addCase(benchmarkActions.fetchAllBenchmarkAttributes.fulfilled, merge({ isLoadingBenchmarkAttributes: false }))
    .addCase(benchmarkActions.fetchAllBenchmarkAttributes.rejected, merge({ isLoadingBenchmarkAttributes: false }))
    .addCase(benchmarkActions.fetchCompaniesBenchmarkSettings.pending, merge({ isLoadingAttributeAssociations: true }))
    .addCase(
      benchmarkActions.fetchCompaniesBenchmarkSettings.fulfilled,
      merge({ isLoadingAttributeAssociations: false }),
    )
    .addCase(
      benchmarkActions.fetchCompaniesBenchmarkSettings.rejected,
      merge({ isLoadingAttributeAssociations: false }),
    )
    .addCase(benchmarkActions.fetchCompanyEmployeeAttributes.pending, merge({ isLoadingEmployeeAttributes: true }))
    .addCase(benchmarkActions.fetchCompanyEmployeeAttributes.fulfilled, merge({ isLoadingEmployeeAttributes: false }))
    .addCase(benchmarkActions.fetchCompanyEmployeeAttributes.rejected, merge({ isLoadingEmployeeAttributes: false }))
    .addCase(benchmarkActions.fetchUnmappedAttributeValues.pending, merge({ isLoadingUnmappedValues: true }))
    .addCase(benchmarkActions.fetchUnmappedAttributeValues.fulfilled, merge({ isLoadingUnmappedValues: false }))
    .addCase(benchmarkActions.fetchUnmappedAttributeValues.rejected, merge({ isLoadingUnmappedValues: false }))
    .addCase(benchmarkActions.fetchBenchmarkQuestions.pending, merge({ isLoadingBenchmarkQuestions: true }))
    .addCase(benchmarkActions.fetchBenchmarkQuestions.fulfilled, merge({ isLoadingBenchmarkQuestions: false }))
    .addCase(benchmarkActions.fetchBenchmarkQuestions.rejected, merge({ isLoadingBenchmarkQuestions: false }))
    .addCase(benchmarkActions.fetchUntaggedSurveyQuestions.pending, merge({ isLoadingUntaggedQuestions: true }))
    .addCase(benchmarkActions.fetchUntaggedSurveyQuestions.fulfilled, merge({ isLoadingUntaggedQuestions: false }))
    .addCase(benchmarkActions.fetchUntaggedSurveyQuestions.rejected, merge({ isLoadingUntaggedQuestions: false }));
});

export { benchmarkUI };
